module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-course-meal-10bdc0266afe7031c677578252735908.jpg";